export const Shopsendpoint = {
  getShopsDetails: `/admin/report/shop-list?vendorId=`,
  getReportsDetails: `/admin/report/sales-record?`,
  getBillDetails:`/admin/report/fetch-bills?`,
};
